
import { Inject, Injectable, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Observable, map, take } from 'rxjs';
import { AccountService } from '../services/account.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private accountService:AccountService,
    private router:Router,
    @Inject(PLATFORM_ID) private platformId: Object) {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (isPlatformBrowser(this.platformId)) {
       if (this.accountService.isAuthenticated()) {
          return true;
        } else {
          window.location.href = '/login';
          return false;
        }
      } else {
        // Handle the case for server-side rendering if needed
        return false;
      }
    
  }
}
